import React, { useState } from "react";
import { RequireStaff } from "@/components/RequireStaff";
import { SMSConversationPanel } from "@/components/sms/SMSConversationPanel";
import SharedMessagesV2 from "@/components/shared/MessagesV2";
import AdminInbox from "@/components/shared/AdminInbox";
import { MessageSquare, Smartphone, MessagesSquare, Inbox } from "lucide-react";

type Tab = "chat" | "sms" | "inbox";

export default function StaffMessages() {
  const [activeTab, setActiveTab] = useState<Tab>("chat");

  const tabs: { id: Tab; label: string; icon: React.ElementType }[] = [
    { id: "chat",  label: "Chat interne",     icon: MessagesSquare },
    { id: "sms",   label: "SMS Twilio",       icon: Smartphone     },
    { id: "inbox", label: "Inbox Plateforme", icon: Inbox          },
  ];

  return (
    <RequireStaff>
      <div className="font-['Geist',sans-serif]">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <MessageSquare className="w-5 h-5 text-primary" />
            <h1 className="text-xl font-semibold">Messages & Chat</h1>
          </div>

          <div className="flex items-center bg-muted/50 rounded-lg p-1 gap-1">
            {tabs.map(tab => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                    activeTab === tab.id
                      ? "bg-background text-foreground shadow-sm"
                      : "text-muted-foreground hover:text-foreground"
                  }`}
                >
                  <Icon className="w-3.5 h-3.5" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {activeTab === "chat" && (
          <div style={{ height: "calc(100vh - 200px)" }}>
            <SharedMessagesV2 role="staff" />
          </div>
        )}
        {activeTab === "sms"   && <SMSConversationPanel />}
        {activeTab === "inbox" && <AdminInbox />}
      </div>
    </RequireStaff>
  );
}
